type PersistOutcome = 'already' | 'granted' | 'denied' | 'unsupported' | 'failed';

type StorageApi = Pick<StorageManager, 'persist' | 'persisted'>;

/**
 * Asks the browser not to evict this origin's IndexedDB, which holds unsynced edits and photo
 * bytes. Chrome answers from engagement (an installed PWA is granted) without a prompt; Firefox
 * prompts once and remembers. Skips the request when storage is already persistent.
 */
export async function requestPersistentStorage(
  storage: Partial<StorageApi> | undefined = globalThis.navigator?.storage,
): Promise<PersistOutcome> {
  const outcome = await ask(storage);
  if (outcome === 'denied' || outcome === 'failed') {
    console.warn(`[storage] persistent storage ${outcome}; the browser may evict local data`);
  } else {
    console.info(`[storage] persistent storage ${outcome}`);
  }
  return outcome;
}

async function ask(storage: Partial<StorageApi> | undefined): Promise<PersistOutcome> {
  if (typeof storage?.persist !== 'function') return 'unsupported';
  try {
    if (typeof storage.persisted === 'function' && (await storage.persisted())) return 'already';
    return (await storage.persist()) ? 'granted' : 'denied';
  } catch {
    return 'failed';
  }
}
